<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3QrXcR/tc-custom/9781512493801.jpg?1718163287006" alt="This image is the cover for the book Sammy Spider's First Shavuot"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sammy Spider's First Shavuot
      </h1>
      <p class="bookDescription body article font2">
        <p>"What's a recipe?" Sammy Spider asks his mother as he watches Mrs. Shapiro make blintzes for Shavuot. As Sammy follows the holiday preparations, young readers will learn how the Torah, which was given on Shavuot, is also a "recipe for life."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sylvia A. Rouss, Katherine Janus Kahn
      </h2>
      
      <p class="authorDescription body article"><B>Katherine Janus Kahn</B> studied Fine Arts at the Bezalel School in Jerusalem and at the University of Iowa. She has illustrated many children's books including Kar-Ben's popular <B>Sammy Spider </B>series. She lives in Wheaton, Maryland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      KAR-BEN PUBLISHING
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06db6385